import { Component, Input } from '@angular/core';

import { SubscriptionState } from '@shared/recurly/enums';
import { AppIcon, AppIconColor, AppIconSize } from '@tablesready/frontend-icons';

@Component({
  selector: 'tablesready-subscription-state',
  templateUrl: './subscription-state.component.html',
  styleUrls: ['./subscription-state.component.scss'],
})
export class SubscriptionStateComponent {
  @Input() state?: SubscriptionState;

  icon = AppIcon;
  iconColor = AppIconColor;
  iconSize = AppIconSize;
  subscriptionState = SubscriptionState;
}
